export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  display: block;
  overflow: hidden;
}
:host section {
  position: relative;
  height: 100%;
}
:host section slicesui-button {
  position: absolute;
  top: 0;
  height: 100%;
  width: 48px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  --slicesui-button-border-color: transparent;
  --slicesui-button-border-radius: 0;
  --slicesui-button-background: var(--slicesui-carousel-button--background);
  --slicesui-button-color: var(--slicesui-carousel-button--color);
}
:host section slicesui-button.left {
  left: 0;
}
:host section slicesui-button.right {
  right: 0;
}
:host section slicesui-button slicesui-icon {
  font-size: var(--slices-text-h1--font-size);
}
:host section main {
  height: 100%;
  white-space: nowrap;
  text-align: center;
}
:host section main > div {
  white-space: nowrap;
  width: 100%;
  height: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
}
:host section main > div ::slotted(*) {
  display: inline-flex;
  min-height: 100%;
}
@supports not (scroll-behavior: smooth) {
  :host section main {
    transition: 1000ms margin ease;
  }
}
@media (hover: none) and (pointer: coarse) {
  :host section slicesui-button {
    //display: none;
  }
  :host section main > div {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
/* width */
/* Track */
/* Handle */
  }
  :host section main > div::-webkit-scrollbar {
    width: 1px;
    display: none;
  }
  :host section main > div::-webkit-scrollbar-track {
    background: transparent;
  }
  :host section main > div::-webkit-scrollbar-thumb {
    background: transparent;
  }
}
`;